if (!customElements.get('announcement-bar')) {
  customElements.define(
    'announcement-bar',
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.messageDuration =
          parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-fade-speed'), 10) ||
          5000;
        this.fadeDuration = 300;
        this.delayBetweenMessages = 300;
        this.close = this.querySelector('.announcement-bar__close');
        /** @type {HTMLElement[]} */
        this.primaryMessages = Array.from(
          this.querySelectorAll('.announcement-bar__messages--primary .announcement-bar__message'),
        );

        this.CLASSES = {
          visible: 'announcement-bar__message--visible',
        };

        if (!this.close) return;

        this.close.addEventListener('click', () => {
          const date = new Date();

          date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
          const expires = 'expires=' + date.toUTCString();
          document.cookie = 'announcement-bar-closed=true;' + expires + ';path=/';

          document.documentElement.style.setProperty('--announcement-bar-height', '0px');
          this.style.display = 'none';
        });
      }

      connectedCallback() {
        if (this.isMobile) return;

        this.showNextMessage();
      }

      showNextMessage() {
        const currentMessage = this.primaryMessages[this.currentIndex];
        currentMessage.classList.add(this.CLASSES.visible);

        setTimeout(() => {
          currentMessage.classList.remove(this.CLASSES.visible);

          setTimeout(() => {
            this.currentIndex = (this.currentIndex + 1) % this.primaryMessages.length;

            this.showNextMessage();
          }, this.fadeDuration + this.delayBetweenMessages);
        }, this.messageDuration);
      }

      get isMobile() {
        return window.innerWidth < 992;
      }
    },
  );
}
